<template>
  <v-list-tile v-if="list">
    <v-list-tile-action>
      <v-icon color="primary" class="theme--light">add_circle</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      {{ $t('message.content.selector.add') }}
    </v-list-tile-content>
  </v-list-tile>
  <v-tooltip top v-else>
    <template #activator="{on}">
      <v-btn v-on="on" class="ma-0" icon>
        <nx-select-entity-wizard :wizards="entityWizards"
                                 :default-value="wizardDefaultValue"
                                 inline />
      </v-btn>
    </template>
    <strong v-html="$t('message.content.selector.add')"></strong>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'nx-list-action-create-entity',
  components: {
    NxSelectEntityWizard: () => import('@/modules/entity/wizard/WizardSelect'),
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    list: {
      type: Boolean,
    },
    captureClick: {
      type: Boolean,
      default: true,
    },
    entityTypes: {
      type: Array,
    },
  },
  data() {
    return {
      showWizard: false,
      wizards: [],
    };
  },
  methods: {
    // se usa un método para abrir el link porque este componente se usa
    // dentro de un slot que tiene el evento @click.capture.stop para evitar
    // que al interactuar con las acciones se abra el link del elemento del listado
    // que contiene estas acciones. Al hacer esto el link no se abre si se intenta
    // de la manera convencional ie :href blabla
    openWizardDialog() {
      this.showWizard = true;
    },
    closeWizard() {
      this.entityWizard = '';
      this.showWizard = false;
    },
    entityCreated(entity) {
      console.log('entity created', entity);
    },
  },
  computed: {
    ...mapGetters(['availableSearcherWizards', 'getWizard']),
    entityWizards() {
      return this.entityTypes.map(entity => this.getWizard(entity));
    },
    wizardDefaultValue() {
      return {
        id: this.item.id,
        list: this.item,
        title: this.item.title,
        [this.item.type]: this.item,
      };
    },
  },
};
</script>
